
import React, { useMemo, useState, useEffect, useRef } from 'react';
import {
  Box, Drawer, List, ListItemButton, ListItemIcon, ListItemText, Collapse, Chip, Tooltip, Snackbar, Alert, IconButton,
} from '@mui/material';
import { ExpandLess, ExpandMore, Logout, Chat, Close } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../Redux/Slices/AuthSlice';
import LogoutModal from './LogoutModel';

// icons ...
import dashboardicon from '../assets/dashboardicon.svg';
import activedashboard from "../assets/activedashboard.svg";
import sidebaricon1 from '../assets/sidebaricon1.svg';
import sidebaricon2 from '../assets/sidebaricon2.svg';
import sidebaricon3 from '../assets/sidebaricon3.svg';
import sidebaricon4 from '../assets/sidebaricon4.svg';
import sidebaricon6 from '../assets/sidebaricon6.svg';
import sidebaricon7 from '../assets/sidebaricon7.svg';
import sidebaricon8 from '../assets/sidebaricon8.svg';
import activenotifications from "../assets/activenotifications.svg";
import activereports from "../assets/activereports.svg";
import activesetting from "../assets/activesettings.svg";
import active from '../assets/active.svg';
import tickets from "../assets/tickets.svg";
import websitelogo from "../assets/websitelogo.png";
import websitelogoes from "../assets/websitelogoes.png";
import deleteicon from "../assets/deleteicon.svg"

const MESSAGE_TOAST_STORAGE_KEY = "account_executive_message_toast_state";

const Sidebar = ({ mobile = false }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { totalCount, totalUnreadCount, superAdminCount, companyAdminCount } = useSelector((state) => state.messageCount);
  const totalMessageCount = (superAdminCount || 0) + (companyAdminCount || 0);
  console.log("🕐 totalUnreadCount", totalUnreadCount);
  console.log("🔢 superAdminCount in sidebar:", superAdminCount);
  console.log("🔢 companyAdminCount in sidebar:", companyAdminCount);

  // Logout modal state
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [showMessageToast, setShowMessageToast] = useState(false);
  const [toastUnreadCount, setToastUnreadCount] = useState(0);
  const previousUnreadRef = useRef(null);

  // Handle logout
  const handleLogout = async () => {
    try {
      setLogoutLoading(true);
      await dispatch(logout());
      navigate("/");
    } finally {
      setLogoutLoading(false);
      setLogoutModalOpen(false);
    }
  };

  // Build menu with labels from i18n but STABLE keys for logic
 const menuItems = useMemo(() => [
    {
      key: 'dashboard',
      label: t('sidebar.dashboard'),
      icon: dashboardicon,
      activeIcon: activedashboard,
      path: '/dashboard',
    },

    {
      key: 'client_acquisition',
      label: t('sidebar.client_acquisition'),
      icon: sidebaricon2,
      children: [
        { key: 'invited_clients', label: t('sidebar.invited_clients'), path: '/invited-clients' },
        { key: 'client_request', label: t('sidebar.client_request'), path: '/clients-requests' },
        { key: 'on_trial', label: t('sidebar.on_trial'), path: '/clients-trial' },
      ],
    },

    {
      key: 'my_clients',
      label: t('sidebar.my_clients'),
      icon: sidebaricon3,
      children: [
        { key: 'active_companies', label: t('sidebar.active_companies'), path: '/active-companies' },
        { key: 'inactive_companies', label: t('sidebar.inactive_companies'), path: '/inactive-companies' },
      ],
    },
  // {
  //     key: 'delete_reuqests',
  //     label: t('deleteRequests'),
  //     icon: deleteicon,
  //     activeIcon: deleteicon,
  //     path: '/delete-requests',
  //   },
    {
      key: 'messages',
      label: t('sidebar.messages'),
      icon: sidebaricon7,
      totalCount: (superAdminCount || 0) + (companyAdminCount || 0),
       path: '/messages',
 
    },

    {
      key: 'wallet',
      label: t('sidebar.wallet'),
      icon: sidebaricon4,
      children: [
        { key: 'my_wallet', label: t('sidebar.my_wallet'), path: '/my-wallet' },
        { key: 'commission_records', label: t('sidebar.commission_records'), path: '/commission-record' },
      ],
    },

    // {
    //   key: 'tickets',
    //   label: t('ticket.management'),
    //   icon: tickets,
    //   activeIcon: tickets,
    //   path: '/ticket-management',
    // },

    {
      key: 'reports',
      label: t('sidebar.report_statistics'),
      icon: sidebaricon6,
      activeIcon: activereports,
      path: '/reports-services',
    },

    {
      key: 'notifications',
      label: t('sidebar.notifications'),
      icon: sidebaricon7,
      activeIcon: activenotifications,
      path: '/notifications',
    },

    {
      key: 'settings',
      label: t('sidebar.account_settings'),
      icon: sidebaricon8,
      activeIcon: activesetting,
      path: '/settings',
    },
    {
      key: 'logout',
      label: t('sidebar.logout') || 'Logout',
      icon: null, // Will use MUI icon
      isLogout: true, // Special flag for logout
    },
  ], [t, totalCount, totalUnreadCount, superAdminCount, companyAdminCount]);

  // Track open parent menus by STABLE key (not label)
const [openMenus, setOpenMenus] = useState({});

  const selectedPath = location.pathname;

  // Auto-open the parent for the current route; re-run on route or language change
// Auto-open the parent for the current route; re-run on route or language change
useEffect(() => {
  const parent = menuItems.find(
    (item) => item.children && item.children.some((c) => c.path === selectedPath)
  );

  if (parent) {
    setOpenMenus((prev) => ({ ...prev, [parent.key]: true }));
  }
}, [selectedPath, menuItems]);

const toggleMenu = (key) => {
  setOpenMenus((prev) => ({
    ...prev,
    [key]: !prev[key], // toggle current
  }));
};
  const language = i18n.language === 'es' ? 'Spanish' : 'English';
  const logoPath = language === 'English' ? websitelogoes : websitelogo;
  useEffect(() => {
    const parent = menuItems.find(
      (item) => item.children && item.children.some((c) => c.path === selectedPath)
    );
  
    if (parent) {
      setOpenMenus({ [parent.key]: true }); 
    } else {
      setOpenMenus({});   
    }
  }, [selectedPath, menuItems]);

  useEffect(() => {
    try {
      const savedToastState = sessionStorage.getItem(MESSAGE_TOAST_STORAGE_KEY);
      if (!savedToastState) return;

      const parsedToastState = JSON.parse(savedToastState);
      if (parsedToastState?.open && parsedToastState?.count > 0) {
        setToastUnreadCount(parsedToastState.count);
        setShowMessageToast(true);
      }
    } catch (error) {
      console.warn("Failed to restore message toast state:", error);
    }
  }, []);

  useEffect(() => {
    const isMessagesPage = location.pathname.includes("/messages");

    if (isMessagesPage) {
      setShowMessageToast(false);
      setToastUnreadCount(0);
      sessionStorage.removeItem(MESSAGE_TOAST_STORAGE_KEY);
      previousUnreadRef.current = totalMessageCount;
      return;
    }

    if (previousUnreadRef.current === null) {
      previousUnreadRef.current = totalMessageCount;
      return;
    }

    if (totalMessageCount > previousUnreadRef.current) {
      setToastUnreadCount(totalMessageCount);
      setShowMessageToast(true);
    }

    previousUnreadRef.current = totalMessageCount;
  }, [totalMessageCount, location.pathname]);

  useEffect(() => {
    if (!showMessageToast || toastUnreadCount <= 0) {
      sessionStorage.removeItem(MESSAGE_TOAST_STORAGE_KEY);
      return;
    }

    sessionStorage.setItem(
      MESSAGE_TOAST_STORAGE_KEY,
      JSON.stringify({ open: true, count: toastUnreadCount })
    );
  }, [showMessageToast, toastUnreadCount]);

  const handleMessageToastClose = (event, reason) => {
    if (reason === "clickaway") return;
    setShowMessageToast(false);
    setToastUnreadCount(0);
  };

  const handleMessageToastNavigate = () => {
    setShowMessageToast(false);
    navigate("/messages");
  };

  const toastMessageText =
    i18n.language === "es"
      ? `${toastUnreadCount} ${toastUnreadCount > 1 ? "mensajes nuevos recibidos" : "mensaje nuevo recibido"}`
      : `${toastUnreadCount} new message${toastUnreadCount > 1 ? "s" : ""} received`;

  return (
    <>
    <Drawer
      variant="permanent"
      sx={{
        width: mobile ? 260 : 210,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 230,
          boxSizing: 'border-box',
          backgroundColor: 'white',
          px: 0,
          borderRight: 'none',
          boxShadow: 'none',
          display: 'flex',
          flexDirection: 'column',
          pl: 1,
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, gap: 2, flexShrink: 0, backgroundColor: 'white', zIndex: 10 }}>
        <img src={logoPath} style={{ width: 180, height: 70, objectFit: 'contain' }} />
      </Box>

      <Box sx={{ flexGrow: 1, overflowY: 'auto', '&::-webkit-scrollbar': { display: 'none' }, scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
        <List sx={{ py: 1 }}>
          {menuItems.map(item => {
            const isChildActive = 'children' in item && item.children.some(c => c.path === selectedPath);
            const isSelfActive = 'path' in item && item.path === selectedPath;

            return (
              <Box
                key={item.key}
                sx={{
                  backgroundColor: isChildActive ? '#F0F9FF' : isSelfActive ? 'rgba(209, 233, 251, 0.58)' : 'transparent',
                  borderRadius: '6px',
                  mb: 1,
                }}
              >
                <ListItemButton
                  onClick={() => {
                    if (item.isLogout) {
                      // Open logout modal
                      setLogoutModalOpen(true);
                    } else if ('children' in item) {
                      toggleMenu(item.key);
                      // optional: navigate to first child on open
                      const firstChild = item.children[0];
                      if (firstChild) navigate(firstChild.path);
                    } else if ('path' in item && item.path) {
                      navigate(item.path);
                    }
                  }}
                  sx={{
                    position: 'relative',
                    gap: 1,
                    px: 2,
                    py: 1,
                    borderRadius: 'children' in item ? '8px 8px 0 0' : '8px',
                    '&:hover': { backgroundColor: item.isLogout ? '#FFEBEE' : '#F0F9FF' },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 25, mr: 0.1 }}>
                    {item.isLogout ? (
                      <Logout sx={{ width: 25, height: 25, color: '#D32F2F' }} />
                    ) : (
                      <img
                        src={isSelfActive && item.activeIcon ? item.activeIcon : item.icon}
                        alt={item.label}
                        style={{ width: 25, height: 25 }}
                      />
                    )}
                  </ListItemIcon>

                  <ListItemText
                    primary={
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <span>{item.label}</span>
                        {item.totalCount > 0 && (
                          <Tooltip title={t('total_messages_count')} arrow>
                            <Chip
                              label={item.totalCount}
                              size="small"
                              sx={{
                                backgroundColor: '#006ec2',
                                color: 'white',
                                fontSize: '10px',
                                height: '18px',
                                minWidth: '18px',
                                '& .MuiChip-label': {
                                  px: 0.5,
                                },
                              }}
                            />
                          </Tooltip>
                        )}
                      </Box>
                    }
                    primaryTypographyProps={{
                      fontSize: '14px',
                      color: item.isLogout ? '#D32F2F' : (isSelfActive ? '#006EC2' : '#44546F'),
                      fontWeight: 500,
                      fontFamily: 'Poppins, sans-serif',
                    }}
                  />

                  {'children' in item && (openMenus[item.key] ? <ExpandLess style={{ width: 20, height: 20 }} /> : <ExpandMore style={{ width: 20, height: 20 }} />)}

                  {isSelfActive && !('children' in item) && (
                    <Box
                      sx={{
                        position: 'absolute',
                        left: 5,
                        top: 13,
                        bottom: 8,
                        width: '3px',
                        height: '23px',
                        borderRadius: '3px',
                        backgroundColor: '#006EC2',
                      }}
                    />
                  )}
                </ListItemButton>

                {'children' in item && (
                  <Collapse in={!!openMenus[item.key]} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      {item.children.map(child => {
                        const isChildSelected = child.path === selectedPath;
                        return (
                          <ListItemButton
                            key={child.key}
                            onClick={() => navigate(child.path)}
                            sx={{
                              position: 'relative',
                              pl: 3,
                              py: 0.7,
                              gap: 1,
                              backgroundColor: isChildSelected ? '#F0F9FF' : 'transparent',
                              borderRadius: '0px 6px 6px 0px',
                              '&:hover': { backgroundColor: '#F3F7FD' },
                            }}
                          >
                            {isChildSelected && (
                              <Box
                                sx={{
                                  position: 'absolute',
                                  left: 0,
                                  top: 12,
                                  bottom: 6,
                                  width: '3px',
                                  backgroundColor: '#006EC2',
                                  borderRadius: '2px',
                                  height: '23px',
                                }}
                              />
                            )}
                            <Box component="img" src={isChildSelected ? active : sidebaricon1} alt="submenu icon" sx={{ width: 10, height: 10, ml: 1, objectFit: 'contain' }} />
                            <ListItemText
                              primary={
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                  <span>{child.label}</span>
                                  {child.count > 0 && (
                                    <Tooltip 
                                      title={child.key === 'super_admin' ? t('super_admin_count') : t('company_admin_count')} 
                                      arrow
                                    >
                                      <Chip
                                        label={child.count}
                                        size="small"
                                        sx={{
                                          backgroundColor: '#006ec2',
                                          color: 'white',
                                          fontSize: '10px',
                                          height: '18px',
                                          minWidth: '18px',
                                          '& .MuiChip-label': {
                                            px: 0.5,
                                          },
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                                </Box>
                              }
                              primaryTypographyProps={{
                                fontSize: '14px',
                                fontWeight: 400,
                                color: isChildSelected ? '#006EC2' : '#44546F',
                                fontFamily: 'Poppins, sans-serif',
                              }}
                            />
                          </ListItemButton>
                        );
                      })}
                    </List>
                  </Collapse>
                )}
              </Box>
            );
          })}
        </List>
      </Box>
    </Drawer>

    {/* Logout Confirmation Modal */}
    <LogoutModal
      open={logoutModalOpen}
      loading={logoutLoading}
      onClose={() => setLogoutModalOpen(false)}
      onConfirm={handleLogout}
    />
    <Snackbar
      open={showMessageToast}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      onClose={handleMessageToastClose}
    >
      <Alert
        severity="info"
        variant="filled"
        icon={<Chat fontSize="small" />}
        onClick={handleMessageToastNavigate}
        sx={{
          cursor: "pointer",
          alignItems: "center",
          ".MuiAlert-message": { py: 0.5 },
        }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={(event) => {
              event.stopPropagation();
              handleMessageToastClose();
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        }
      >
        {toastMessageText}
      </Alert>
    </Snackbar>
    </>
  );
};

export default Sidebar;

// import React, { useState } from 'react';
// import {
//   Box,
//   Drawer,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Collapse,
// } from '@mui/material';
// import { ExpandLess, ExpandMore } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';
// import logo1 from '../assets/logo1.svg';
// import logo2 from '../assets/logo2.svg';
// import dashboardicon from '../assets/dashboardicon.svg';
// import sidebaricon1 from '../assets/sidebaricon1.svg';
// import sidebaricon2 from '../assets/sidebaricon2.svg';
// import sidebaricon3 from '../assets/sidebaricon3.svg';
// import sidebaricon4 from '../assets/sidebaricon4.svg';
// import sidebaricon5 from '../assets/sidebaricon5.svg';
// import sidebaricon6 from '../assets/sidebaricon6.svg';
// import sidebaricon7 from '../assets/sidebaricon7.svg';
// import sidebaricon8 from '../assets/sidebaricon8.svg';
// import active from '../assets/active.svg';
// import { useLocation } from 'react-router-dom';
// import activenotifications from "../assets/activenotifications.svg";
// import activedashboard from "../assets/activedashboard.svg";
// import activesetting from "../assets/activesettings.svg";
// import activereports from "../assets/activereports.svg";
// import { useTranslation } from 'react-i18next';
// import websitelogo from "../assets/websitelogo.png"; 
// import websitelogoes from "../assets/websitelogoes.png"; 
// import tickets from "../assets/tickets.svg"


// const Sidebar = ({ mobile = false, onClose }) => {
//    const { t, i18n } = useTranslation();
//   const [openMenus, setOpenMenus] = useState({});

//   const menuItems = [
  
//   {
//     label: t('sidebar.dashboard'),
//     icon: dashboardicon,
//     activeIcon: activedashboard,
//     path: '/dashboard',
//   },
//   {
//     label: t('sidebar.client_acquisition'),
//     icon: sidebaricon2,
//     children: [
//       { label: t('sidebar.invited_clients'), path: '/invited-clients' },
//       { label: t('sidebar.client_request'), path: '/clients-requests' },
//       { label: t('sidebar.on_trial'), path: '/clients-trial' },
//     ],
//   },
//   {
//     label: t('sidebar.my_clients'),
//     icon: sidebaricon3,
//     children: [
//       { label: t('sidebar.active_companies'), path: '/active-companies' },
//       { label: t('sidebar.inactive_companies'), path: '/inactive-companies' },
//     ],
//   },
//   {
//     label: t('sidebar.wallet'),
//     icon: sidebaricon4,
//     children: [
//       { label: t('sidebar.my_wallet'), path: '/my-wallet' },
//       { label: t('sidebar.commission_records'), path: '/commission-record' },
//     ],
//   },
//   // {
//   //   label: t('sidebar.messages'),
//   //   icon: sidebaricon5,
//   //   children: [
//   //     { label: t('sidebar.inbox'), path: '/messages' },
//   //     { label: t('sidebar.support'), path: '/support' },
//   //   ],
//   // },
//     {
//     label: t('ticket.management'),
//     icon: tickets,
//     activeIcon: tickets,
//     path: "/ticket-management"
//   },
//   {
//     label: t('sidebar.report_statistics'),
//     icon: sidebaricon6,
//     activeIcon: activereports,
//     path: "/reports-services"
//   },
//   {
//     label: t('sidebar.notifications'),
//     icon: sidebaricon7,
//     activeIcon: activenotifications,
//     path: "/notifications"
//   },
//   {
//     label: t('sidebar.account_settings'),
//     icon: sidebaricon8,
//     activeIcon: activesetting,
//     path: "/settings"
//   },
// ];

// const location = useLocation();

// const getSelectedLabel = () => {
//   const currentPath = location.pathname;

//   for (const item of menuItems) {
//     if (item.path && item.path === currentPath) return item.label;

//     if (item.children) {
//       for (const child of item.children) {
//         if (child.path === currentPath) return child.label;
//       }
//     }
//   }
//   return '';
// };
// const [selectedItem, setSelectedItem] = useState(getSelectedLabel());
// const navigate = useNavigate();
//  const toggleMenu = (label) => {
//   setOpenMenus((prev) => ({
//     [label]: !prev[label] // toggle current
//   }));
// };
// const language = i18n.language === 'es' ? 'Spanish' : 'English';

//   const Logopath = language === 'English' ? websitelogoes: websitelogo;
//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: mobile ? 260 : 210,
//         flexShrink: 0,
//         '& .MuiDrawer-paper': {
//           width: 230,
//           boxSizing: 'border-box',
//           backgroundColor: 'white',
//           px: 0,
//           borderRight: 'none',
//           boxShadow: 'none',
//           display: 'flex',
//           flexDirection: 'column',
//           pl:1,
//         },
//       }}
//     >
//       {/* Logo */}
//       <Box
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//        pl:1,
//           gap: 2,
//           flexShrink: 0,
//           backgroundColor: 'white',
//           zIndex: 10,
//         }}
//       >
//            <img src={Logopath}  style={{width:180,height:70,objectFit:"contain"}}/>
//       </Box>

//       {/* Menu List */}
//       <Box
//         sx={{
//           flexGrow: 1,
//           overflowY: 'auto',
//           '&::-webkit-scrollbar': { display: 'none' },
//           scrollbarWidth: 'none',
//           msOverflowStyle: 'none',
//         }}
//       >
//         <List sx={{ py: 1 }}>
//           {menuItems.map((item) => {
//             const isChildSelected = item.children?.some(child => child.label === selectedItem);
//             const isSelfSelected = selectedItem === item.label;

//             return (
//               <Box
//                 key={item.label}
//                 sx={{
//                   backgroundColor: isChildSelected ? '#F0F9FF' : isSelfSelected ? 'rgba(209, 233, 251, 0.58)' : 'transparent',
//                   borderRadius: '6px',
//                   mb: 1, 
                  
//                 }}
//               >
//                 <ListItemButton
//            onClick={() => {
//   if (item.children) {
//     toggleMenu(item.label);
//     const firstChild = item.children[0];
//     setSelectedItem(firstChild.label);
//     navigate(firstChild.path); // 👈 navigate to first child
//   } else {
//     setSelectedItem(item.label);
//     if (item.path) navigate(item.path); // 👈 navigate if it has a path
//   }
// }}
//                   sx={{
//                     position: 'relative',
//                     gap: 1,
//                     px: 2,
//                     py: 1,
//                     borderRadius: item.children ? '8px 8px 0 0' : '8px',
//                     '&:hover': {
//                       backgroundColor: '#F0F9FF',
//                     },
//                   }}
//                 >
          
//                   <ListItemIcon sx={{ minWidth: 25, mr: 0.1 }}>
//   <img
//     src={
//       isSelfSelected && item.activeIcon
//         ? item.activeIcon
//         : item.icon
//     }
//     alt={item.label}
//     style={{ width: 25, height: 25 }}
//   />
// </ListItemIcon>
//                   <ListItemText
//                     primary={item.label}
//                     primaryTypographyProps={{
//                       fontSize: '14px',
//                       color: isSelfSelected ? '#006EC2' : '#44546F',
//                       fontWeight: 500,
//                       fontFamily: 'Poppins, sans-serif',
//                     }}
//                   />
//                   {item.children && (
//                     openMenus[item.label]
//                       ? <ExpandLess style={{ width: 20, height: 20 }} />
//                       : <ExpandMore style={{ width: 20, height: 20 }} />
//                   )}
//          {isSelfSelected && !item.children && (
//     <Box
//       sx={{
//         position: 'absolute',
//     left: 5,
//         top: 13,
//         bottom: 8,
//         width: '3px',
//         height:"23px",
//         borderRadius: '3px',
//         backgroundColor: '#006EC2',
//       }}
//     />
//   )}
//                 </ListItemButton>

//                 {/* Children */}
//                 {item.children && (
//                   <Collapse in={openMenus[item.label]} timeout="auto" unmountOnExit>
//                     <List component="div" disablePadding>
//                       {item.children.map((child) => {
//                         const isChildActive = selectedItem === child.label;

//                         return (

// <ListItemButton
//   key={child.label}
//   onClick={() => {
//     setSelectedItem(child.label);
//     navigate(child.path);
//   }}
//   sx={{
//     position: 'relative',
//     pl: 3,
//     py: 0.7,
//     gap: 1,
//     backgroundColor: isChildActive ? '#F0F9FF' : 'transparent',
//     borderRadius: '0px 6px 6px 0px',
//     '&:hover': {
//       backgroundColor: '#F3F7FD',
//     },
//   }}
// >
//   {/* 🔵 Left vertical line with spacing */}
//   {isChildActive && (
//     <Box
//       sx={{
//         position: 'absolute',
//         left: 0,
//         top: 12,           // space from top
//         bottom: 6,        // space from bottom
//         width: '3px',
//         backgroundColor: '#006EC2',
//         borderRadius: '2px',
//         height:"23px"
//       }}
//     />
//   )}

//   <Box
//     component="img"
//     src={isChildActive ? active : sidebaricon1}
//     alt="submenu icon"
//     sx={{ width: 10, height: 10, ml: 1, objectFit: 'contain' }}
//   />
//   <ListItemText
//     primary={child.label}
//     primaryTypographyProps={{
//       fontSize: '14px',
//       fontWeight: 400,
//       color: isChildActive ? '#006EC2' : '#44546F',
//       fontFamily: 'Poppins, sans-serif',
//     }}
//   />
// </ListItemButton>
//                         );
//                       })}
//                     </List>
//                   </Collapse>
//                 )}
//               </Box>
//             );
//           })}
//         </List>
//       </Box>
//     </Drawer>
//   );
// };
// export default Sidebar;